export const getStyles = (_, { palette = {} }) => ({
  subTitleContainer: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21px',
    marginBottom: 32,
    color: palette.neutralPrimary,
    textAlign: 'center',
  },
});
